import { GroupBase, IndicatorSeparatorProps } from "react-select";
import Option from "../../interfaces/Option/Option";

export const CustomIndicatorSeparator = (props: IndicatorSeparatorProps<Option, boolean, GroupBase<Option>>) => (
    props.selectProps.isLoading || (props.selectProps.isLoggedIn && props.isDisabled)
        ? null
        : <div className={"form-field-create-username__status " + (props.selectProps.selectedIsValid 
            ? 'form-field-create-username__status--available' 
            : props.selectProps.selectedIsValid !== undefined 
                ? 'form-field-create-username__status--unavailable'
                : null)}>
            <span className="form-field-create-username__status-icon"></span>
            <span className="form-field-create-username__status-available">
                {props.selectProps.availableText}
            </span>
            <span className="form-field-create-username__status-not-available">
                {props.selectProps.notAvailableText}
            </span>
        </div>
);
